import CongratsPopUp from "./CongratsPopUp";

export default CongratsPopUp;
